import React from "react";
import ItemsBase from "../../common/components/ItemsBase";
import Empty from "../components/Empty";
import Item from "./Item";
import branch from "../../common/containers/branch";

export class Items extends ItemsBase {
	constructor(props, context) {
		super(props, context);
	}

	renderItemsEmpty() {
		return <Empty />;
	}

	renderItems(items) {
		const content = [];

		for (let i = 0; i < items.length; i++) {
			content.push(
				<Item
					hasPrice={this.hasPrice}
					hasMonthlyPrice={this.hasMonthlyPrice}
					item={items[i]}
					readOnly={this.props.readOnly}
				/>
			);
		}

		return <ul className="shopping-list">{content}</ul>;
	}

	render() {
		return this.renderContent(false);
	}
}

export default branch(Items);
